var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "game-tag-tab" },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "page",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleAddTag },
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleRefresh },
                      },
                      [_vm._v("刷新")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colImageUrl",
            fn: function ({ row }) {
              return [
                row.image_url
                  ? _c("el-image", {
                      staticStyle: {
                        width: "36px",
                        height: "36px",
                        "border-radius": "4px",
                      },
                      attrs: {
                        src: row.image_url,
                        fit: "cover",
                        "preview-src-list": [row.image_url],
                      },
                    })
                  : _c("span", [_vm._v("无图标")]),
              ]
            },
          },
          {
            key: "colHasGameCount",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleRelateGames(row)
                      },
                    },
                  },
                  [_vm._v(_vm._s(row.has_game_count))]
                ),
              ]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c("el-switch", {
                  attrs: { "active-value": 1, "inactive-value": 2 },
                  on: {
                    change: function ($event) {
                      return _vm.handleStatusChange(row.id, row.status)
                    },
                  },
                  model: {
                    value: row.status,
                    callback: function ($$v) {
                      _vm.$set(row, "status", $$v)
                    },
                    expression: "row.status",
                  },
                }),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleRelateGameList(row)
                      },
                    },
                  },
                  [_vm._v("关联游戏")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEditTag(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "danger-button",
                    attrs: { type: "text", size: "small", danger: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDeleteTag(row)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("ManageGameTagDialog", {
        attrs: { visible: _vm.tagDialogVisible, "tag-data": _vm.currentTag },
        on: {
          "update:visible": function ($event) {
            _vm.tagDialogVisible = $event
          },
          "save-success": _vm.handleTagSaveSuccess,
        },
      }),
      _c("ManageGameTagRelationDialog", {
        attrs: {
          visible: _vm.relationDialogVisible,
          "tag-data": _vm.currentTag,
        },
        on: {
          "update:visible": function ($event) {
            _vm.relationDialogVisible = $event
          },
          "save-success": _vm.handleRelationSaveSuccess,
        },
      }),
      _c("ManageGameTagBatchRelateGameDialog", {
        attrs: {
          visible: _vm.batchRelateDialogVisible,
          "tag-data": _vm.currentTag,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchRelateDialogVisible = $event
          },
          "save-success": _vm.handleBatchRelateSaveSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }